import { Splide } from "@splidejs/splide";
import { Video } from "@splidejs/splide-extension-video";

/*
 * Viode Slider
 */
const videoSlider = () => {
  const sliderDiv = document.getElementById("sliderHolder");
  if (sliderDiv) {
    new Splide(sliderDiv, {}).mount({ Video });
  }
};

videoSlider();

// inner header slider
const heroSlider = () => {
  const sliderDiv = document.getElementById("heroSlider");
  if (sliderDiv) {
    new Splide(sliderDiv, {}).mount({});
  }
};

heroSlider();

/*
 * Product Info Slider
 */

const productInfoSliderDiv = document.getElementById("productInfoSlider");
const productInfoSliderContentDiv = document.getElementById(
  "productInfoSliderContent"
);

if (productInfoSliderDiv && productInfoSliderContentDiv) {
  const productInfoSlider = new Splide(productInfoSliderDiv, {
    type: "loop",
    arrows: true,
    perPage: 1,
    speed: 600,
    rewind: false,
    perMove: 1,
    waitForTransition: true,

    classes: {
      arrows: "splide__arrows your-class-arrows",
      arrow: "splide__arrow your-class-arrow",
      prev: "splide__arrow--prev your-class-prev",
      next: "splide__arrow--next your-class-next",
    },
    pagination: false,
    breakpoints: {
      768: {
        pagination: true,
        arrows: false,
        padding: "150px",
        speed: 350,
        flickPower: 100,
        flickMaxPages: 1,
        waitForTransition: true,
        updateOnMove: true,
      },

      560: {
        padding: "130px",
      },
      500: {
        padding: "100px",
      },
      400: {
        padding: "90px",
      },
      350: {
        padding: "70px",
      },
    },
  });

  //Product Info slider right half (nutritions/ingreedients)
  const productInfoSliderContent = new Splide(productInfoSliderContentDiv, {
    type: "fade",
    rewind: true,
    arrows: false,
    perPage: 1,
    speed: 600,
    pagination: false,
    drag: false,
  });

  productInfoSlider.sync(productInfoSliderContent);
  productInfoSlider.mount({});
  productInfoSliderContent.mount({});

  let sectionDiv = document.querySelector(".product-info") as HTMLElement;

  if (sectionDiv) {
    const nextArrow = document.querySelector(
      ".splide__arrow--next"
    ) as HTMLButtonElement;
    const prevArrow = document.querySelector(
      ".splide__arrow--prev"
    ) as HTMLButtonElement;

    // Set initial background color
    let currentSlide = document.querySelector("#productInfoSlider .splide__slide.is-active");
    let bgColor = currentSlide?.getAttribute("data-color");
    if (bgColor) {
      sectionDiv.style.background = bgColor;
    }

    //Change backround color on arrows click
    if (prevArrow && nextArrow) {
      nextArrow.addEventListener("click", (e) => {
        let nextSlide = document.querySelector(
          "#productInfoSlider .splide__slide.is-next"
        );
        let bgColor = nextSlide?.getAttribute("data-color");

        if (bgColor) {
          sectionDiv.style.background = bgColor;
        }
      });

      prevArrow.addEventListener("click", (e) => {
        let prevSlide = document.querySelector(
          "#productInfoSlider .splide__slide.is-prev"
        );
        let bgColor = prevSlide?.getAttribute("data-color");

        if (bgColor) {
          sectionDiv.style.background = bgColor;
        }
      });
    }

    //Change background color on product info slider move
    productInfoSlider.on("move", function (newIndex, prevIndex, destIndex) {
      let currentSlide = document.querySelector(
        "#productInfoSlider .splide__slide.is-active"
      );
      let productInfoSlider = document.querySelector(
        "#productInfoSliderContent .splide__slide.is-active"
      );
      let bgColor = currentSlide?.getAttribute("data-color");

      if (bgColor) {
        sectionDiv.style.background = bgColor;
      }
    });

    //Change mobile product title after product info slider moved
    productInfoSlider.on("moved", function (newIndex, prevIndex, destIndex) {
      let productInfoSlider = document.querySelector(
        "#productInfoSliderContent .splide__slide.is-active"
      );

      updateMobileTitle(productInfoSlider);
    });
  }
}

/*
 * function updateMobileTitle
 *
 * Duplicates product title and description to another element that is visible only on mobile,
 * after each slide change
 */
function updateMobileTitle(slide) {
  let mobileTitleWrap = document.querySelector(
    ".product-info__mobile-title"
  ) as HTMLElement;
  let mobileTitle = document.querySelector(".product-info__mobile-title h2");
  let mobileDescription = document.querySelector(
    ".product-info__mobile-title p"
  );

  let title = slide?.querySelector("h2");
  let description = slide?.querySelector("p");

  if (
    mobileTitle &&
    mobileDescription &&
    title &&
    description &&
    mobileTitleWrap
  ) {
    mobileTitleWrap.style.opacity = "0";

    setTimeout(() => {
      if (mobileTitle && mobileDescription) {
        mobileTitle.textContent = title.textContent;
        mobileDescription.textContent = description.textContent;
        mobileTitleWrap.style.opacity = "1";
      }
    }, 160);
  }
}

//On page load, sync desktop and mobile slider title and description
document.addEventListener("DOMContentLoaded", function () {
  let firstSlide = document.querySelector(
    "#productInfoSliderContent .splide__slide.is-active"
  );
  updateMobileTitle(firstSlide);
});

// B2B slider
const b2bSliderInit = () => {
  const b2bSliderDiv = document.getElementById("b2bSlider");
  if (b2bSliderDiv) {
    const b2bSlider = new Splide(b2bSliderDiv, {
      type: "fade",
      autoplay: true,
      interval: 3000,
      rewind: true,
      arrows: false,
      perPage: 1,
      speed: 1000,
      pagination: true,
      drag: true,
      width: "360px",
      height: "90px",
    });

    b2bSlider.mount({});

    const sliderWrap = document.getElementById("sliderWrap");
    const sliderShape = document.getElementById("b2bSliderShape");
    
    b2bSlider.on("moved", function (newIndex, prevIndex, destIndex) {
      let currentSlide = document.querySelector(
        "#b2bSlider .splide__slide.is-active"
      );
      let borderColor = currentSlide?.getAttribute("data-color");
    
      if (borderColor && sliderWrap && sliderShape) {
        sliderWrap.style.borderColor = borderColor;
        sliderShape.style.backgroundColor = borderColor;

        if (newIndex % 2 == 0) {
          sliderShape.style.transform = "rotate(171deg)";
        } else {
          sliderShape.style.transform = "rotate(190deg)";
        }
      }
    });
  }
};

b2bSliderInit();
